<template>
 <div>
      <zj-layout-container>
         <zj-layout-main>
          <div class="zj-layout-main-content bgcolor scrollable">
           <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="Keywords" label="关键词" width="100"></el-table-column>
              <el-table-column prop="FirstWebContentSite" label="来源" width="100"></el-table-column>
              <el-table-column prop="Title" label="标题" show-overflow-tooltip></el-table-column>
              <el-table-column prop="Similarity" label="热度" width="80"></el-table-column>
              <el-table-column label="属性" prop="State" width="80">
                <template slot-scope="scope">
                 <span class="iconGood" v-if="scope.row.State==1"><span>正</span></span>
                 <span class="iconBad"  v-else><span>负</span></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
         </zj-layout-main>
      </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionTopics",
  controller: "UI",
  action: "OpinionTopics",
  data() {
      return {
      loading: false,
      loadingText: '加载中...',
      tableData:[]
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
       let that = this;
       new MyApis.OpinionApi()
        .GetTopTenTopics()
        .then((r) => {
          r = r.data.Data;
          this.tableData=r;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });

    },
        //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd");
    },
  }
}

</script>
